export const API_GET_ALL_PRODUCTS = "/admin/productos/";
export const API_GET_SEARCH_PRODUCTS = "/admin/productos/buscar/";
export const API_POST_SAVE_PRODUCTS = "/admin/productos/registro-producto";
export const API_PUT_UPDATE_PRODUCTS = "/admin/productos/actualizar-producto/";
export const API_GET_ALL_MEASURES = "/admin/unidadMedida/buscar/medida";
export const API_GET_SEARCH_FAMILY_MEASURES = "/admin/unidadMedida/buscar/familiaMedida";
export const API_GET_SEARCH_UNIT_MEASURES = "/admin/unidadMedida/buscar/unidadMedida";
export const API_GET_ALL_CODING_SEGMENT_PA = "/admin/bienesServicios/buscar/segmento";
export const API_GET_SEARCH_CODING_FAMILY_PA = "/admin/bienesServicios/buscar/familia";